import { Divider as AntDivider, type DividerProps } from 'antd';
import type { FC } from 'react';

type Size = 'xs' | 'sm' | 'md' | 'lg';

type Props = Pick<
  DividerProps,
  'type' | 'orientation' | 'children' | 'style' | 'plain'
> & {
  size?: Size;
};

export const Divider: FC<Props> = ({ size = 'sm', style, ...rest }) => {
  return (
    <AntDivider
      {...rest}
      style={{
        ...(rest.type === 'vertical'
          ? { marginLeft: sizeMapper[size], marginRight: sizeMapper[size] }
          : { marginTop: sizeMapper[size], marginBottom: sizeMapper[size] }),
        // TODO: remove style to prevent freedom usage.
        ...style,
      }}
    />
  );
};

const sizeMapper = {
  xs: 0,
  sm: 8,
  md: 16,
  lg: 24,
} as const satisfies Record<Size, number>;
